var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{key:_vm.key}),_c('div',{style:({ display: _vm.key != '/' ? 'block' : 'none' }),attrs:{"id":"container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }